import create from 'zustand'

export const useStoreAnswered = create(set => ({
    answeredQestions: 0,
    addUseStoreAnswered: () => set(state => ({ answeredQestions: state.answeredQestions + 1 })), 
}))

